import { createSlice } from '@reduxjs/toolkit';
import axios from 'axios';
import { dispatch } from '../store';

const initialState = {
  list: {
    next: 1,
    previous: null,
    current_page: 1,
    count: 1,
    total_pages: 1,
    results: [],
  },
  isGettingCategoriesList: false,
};

export const mainCategorySlice = createSlice({
  name: 'mainCategory',
  initialState,
  reducers: {
    setMainCategoryList: (state, action) => {
      const data = action.payload;
      state.list = {
        ...data,
        results: [...state.list.results, ...data.results],
      };
    },
    setIsGettingMainCategoryList: (state, action) => {
      state.isGettingCategoriesList = action.payload;
    },
    clearMainCategoryList: (state) => {
      state.list = {
        next: 1,
        previous: null,
        current_page: 1,
        count: 1,
        total_pages: 1,
        results: [],
      };
    },
    removeMainCategory: (state, action) => {
      const data = action.payload;
      state.list.results = state.list.results.filter((category) => !data.includes(category.id));
    },
    addMainCategory: (state, action) => {
      const payload = action.payload;
      state.list.results = [...payload, ...state.list.results];
    },
    updateMainCategory: (state, action) => {
      const updatedCategory = action.payload;
      const index = state.list.results.findIndex((category) => category.id === updatedCategory.id);
      if (index !== -1) {
        state.list.results[index] = updatedCategory;
      }
    },
  },
});

export const {
  setMainCategoryList,
  clearMainCategoryList,
  setIsGettingMainCategoryList,
  removeMainCategory,
  addMainCategory,
  updateMainCategory,
} = mainCategorySlice.actions;

export default mainCategorySlice.reducer;

export const handleClearMainCategoryList = () => {
  dispatch(clearMainCategoryList());
};

export const handleGetMainCategoriesList = async (filters) => {
  dispatch(setIsGettingMainCategoryList(true));

  try {
    const link = `main-category/list/?query=${filters.query}&page_size=${filters.pageSize}&page=${filters.page + 1}&order_by=${filters.order_by}`;

    const res = await axios.get(link);
    if (res.status === 200) {
      if (parseInt(filters.page, 10) + 1 === 1) {
        dispatch(clearMainCategoryList());
      }
      const data = res.data;
      dispatch(setMainCategoryList(data));
      dispatch(setIsGettingMainCategoryList(false));
    }
    return Promise.resolve();
  } catch (err) {
    console.log('🚀 ~ handleGetMainCategoriesList ~ err:', err);
    dispatch(setIsGettingMainCategoryList(false));
    return Promise.reject(err);
  }
};

export const handleAddMainCategory = async (category) => {
  try {
    const response = await axios.post('main-category/', category);
    dispatch(addMainCategory([response.data]));
    return Promise.resolve();
  } catch (err) {
    return Promise.reject();
  }
};

export const handleRemoveMainCategory = async (data) => {
  try {
    await axios.post('main-category/remove/', { data });
    dispatch(removeMainCategory(data));
    return Promise.resolve();
  } catch (err) {
    return Promise.reject();
  }
};

export const handleUpdateMainCategory = async (category) => {
  try {
    const response = await axios.put(`main-category/`, category);
    dispatch(updateMainCategory(response.data));
    return Promise.resolve();
  } catch (err) {
    return Promise.reject(err);
  }
};
